var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',[_c('div',{staticClass:"tw-w-full"},[_c('bread-crumb',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('quotes')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }